import React from "react";
import Kanban from "../sales/Kanban";

export default function AdminEmpfehlungen() {
  return <Kanban />;
}
